import { Component } from 'react'
import { API } from 'aws-amplify'
import withRouter from '../components/withRouter'
import moment from 'moment'
import TopMenu from '../components/topMenu'
import BottomMenu from '../components/bottomMenu'
import HeatMap from '../components/heatmap'
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js'
import { Bar } from 'react-chartjs-2'
import Logo from '../images/GigLoca_Logo_Light.png'
import './node.css'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

class Analytics extends Component {
    constructor(props) {
        super(props)

        this.state = {
            splash: true,
            bounce: false,
            route: null,
            displayMessage: false,
            msg: '',
            data: null,
            heatmap: null,
            menu: {
                left: 'dashboard',
                right: '',
                mode: 'Analytics',
                action: 'refresh'
            },
            id: null,
            lat: null,
            lng: null,
            dailyData: null
        }

        this.handleOnPrefSelect = this.handleOnPrefSelect.bind(this)
        this.handleDisplaySettings = this.handleDisplaySettings.bind(this)
        this.handleModeChange = this.handleModeChange.bind(this)
        this.handleOnNotificationsSelect = this.handleOnNotificationsSelect.bind(this)
        this.handleLeftMenu = this.handleLeftMenu.bind(this)
        this.handleGiglit = this.handleGiglit.bind(this)

    }

    componentDidMount() {
        if (this.props.isAuthenticated && this.props.user && this.props.user.premium) {
            const { path, search } = this.props
            const id = path.id
            const route = search.pathname.toLowerCase() === `/my/venue/${id}/analytics` ? 'Venue' : 'Contributor'
            this.props.setMode(route)
            if (this.props.myNodes) {
                if (route === 'Venue') {
                    const idx = this.props.myNodes.Venue ? this.props.myNodes.Venue.findIndex(v => v.id === id) : -1
                    if (idx > -1) {
                        this.setState({
                            id,
                            route,
                            data: this.props.myNodes.Venue[idx],
                            node: 'Venue',
                            splash: false,
                            lat: this.props.myNodes.Venue[idx].address.coord.lat,
                            lng: this.props.myNodes.Venue[idx].address.coord.lng
                        })
                        this.getData(id, moment().date(1).format('YYYY-MM-DD'), moment().date(1).add(1, 'month').format('YYYY-MM-DD'))
                    } else {
                        API.get('lt', `my/${id}`)
                            .then(resp => {
                                if (this.props.myNodes) {
                                    this.props.setMy([...this.props.myNodes.Venue, ...resp.data.Venue])
                                } else this.props.setMy(resp.data.Venue)
                                this.setState({
                                    id,
                                    route,
                                    data: resp.data.Venue[0],
                                    node: 'Venue',
                                    splash: false,
                                    lat: resp.data.Venue[0].address.coord.lat,
                                    lng: resp.data.Venue[0].address.coord.lng
                                })
                            })
                            .catch(err => {
                                console.log(err)
                                if (err.response && err.response.status && err.response.status === 403) {
                                    this.handleNavigate('main')
                                } else setTimeout(() => this.handleNavigate(`my/venues`), 150)
                            })
                    }
                } else {
                    let node = ''
                    let data = null
                    Object.keys(this.props.myNodes).forEach(key => this.props.myNodes[key].forEach(n => {
                        if (n.id === id) {
                            node = key
                            data = n
                        }
                    }))
                    if (node.length > 0 && data) {
                        this.setState({
                            id,
                            route,
                            data,
                            node,
                            splash: false
                        })
                        this.getData(id, moment().date(1).format('YYYY-MM-DD'), moment().date(1).add(1, 'month').format('YYYY-MM-DD'))
                    } else setTimeout(() => this.handleNavigate(`my/contributors`), 150)
                }
            } else {
                API.get('lt', `my`)
                    .then(resp => {
                        let myNodes = resp.data
                        this.props.setMy(myNodes)
                        if (route === 'Venue') {
                            const idx = resp.data.Venue ? resp.data.Venue.findIndex(v => v.id === id) : -1
                            if (idx > -1) {
                                this.setState({
                                    id,
                                    route,
                                    data: resp.data.Venue[idx],
                                    node: 'Analytics',
                                    splash: false,
                                    lat: resp.data.Venue[0].address.coord.lat,
                                    lng: resp.data.Venue[0].address.coord.lng
                                })
                                this.getData(id, moment().date(1).format('YYYY-MM-DD'), moment().date(1).add(1, 'month').format('YYYY-MM-DD'))
                            } else {
                                API.get('lt', `my/${id}`)
                                    .then(resp => {
                                        if (myNodes.Venue) {
                                            myNodes.Venue = [...myNodes.Venue, ...resp.data.Venue]
                                        } else myNodes.Venue = resp.data.Venue
                                        this.props.setMy(myNodes)
                                        this.setState({
                                            id,
                                            route,
                                            data: resp.data.Venue[0],
                                            node: 'Analytics',
                                            splash: false,
                                            lat: resp.data.Venue[0].address.coord.lat,
                                            lng: resp.data.Venue[0].address.coord.lng
                                        })
                                    })
                                    .catch(err => {
                                        console.log(err)
                                        if (err.response && err.response.status && err.response.status === 403) {
                                            this.handleNavigate('main')
                                        } else setTimeout(() => this.handleNavigate(`my/venues`), 150)
                                    })
                            }
                        } else {
                            let node = ''
                            let data = null
                            Object.keys(resp.data).forEach(key => resp.data[key].forEach(n => {
                                if (n.id === id) {
                                    node = key
                                    data = n
                                }
                            }))
                            if (node.length > 0 && data) {
                                this.setState({
                                    id,
                                    route,
                                    data,
                                    node,
                                    splash: false,
                                    lat: this.props.myLoc.lat,
                                    lng: this.props.myLoc.lng
                                })
                                this.getData(id, moment().date(1).format('YYYY-MM-DD'), moment().date(1).add(1, 'month').format('YYYY-MM-DD'))
                            } else setTimeout(() => this.handleNavigate(`my/contributors`), 150)
                        }
                    })
                    .catch(err => {
                        console.log(err)
                        if (err.response && err.response.status && err.response.status === 403) {
                            this.handleNavigate('main')
                        } else this.setState({ msg: err.response && err.response.data && err.response.data.error ? err.response.data.error : err.message, displayMsg: true })
                    })
            }
        } else {
            this.setState({ splash: false, bounce: true })
            setTimeout(() => {
                this.handleNavigate('main', true)
            }, 3000)
        }
    }

    handleNavigate(page, history) {
        const { search } = this.props
        if (history) this.props.onAddHistory(search.pathname + search.search)
        const { navigate } = this.props
        navigate(`/${page}`)
    }

    handleBack() {
        this.handleNavigate(`my/${this.state.route}s`, true)
    }

    handleDisplaySettings() {
        this.setState({ displaySearch: false, displaySettings: !this.state.displaySettings })
    }

    handleModeChange(mode) {
        if (mode) {
            if (mode === 'contactus') {
                this.handleNavigate('contactus')
            } else if (mode === 'tix') {
                this.handleNavigate('tixcheck')
            } else if (mode !== 'fan') {
                this.props.setMode(mode)
                this.handleNavigate(`my/${mode === 'Venue' ? 'venues' : 'contributors'}`, true)
            } else this.handleNavigate('', true)
        }
        this.setState({ displaySettings: false })
    }

    handleOnNotificationsSelect() {
        this.handleNavigate('notifications', true)
    }

    handleOnPrefSelect() {
        this.handleNavigate('profile')
    }

    handleGiglit() {
        this.getData()
    }

    handleLeftMenu() {
        this.handleNavigate(`my/${this.state.route}s`, true)
    }

    handleMsgOK() {
        this.setState({ msg: '', displayMsg: false, isSaving: false })
    }

    getData(id, start, end) {
        if (!this.state.isLoading) {
            this.setState({ isLoading: true })
            API.get('lt', `my/${id || this.state.id}`)
                .then(resp => {
                    let heatmap, dailyData
                    if (resp.analytics) {
                        heatmap = resp.analytics.map(a => { return { lat: a.lat, lng: a.lng } })
                        dailyData = [] 
                        resp.analytics.forEach(d => {
                            const ddidx = dailyData.findIndex(dd => Object.keys(dd)[0] === moment(d.ts).format('ll'))
                            if(ddidx > -1) {
                                dailyData[ddidx] = {[Object.keys(dailyData[ddidx])[0]]: Object.values(dailyData[ddidx])[0] += 1}
                            } else {
                                let daily = moment(d.ts).format('ll')
                                dailyData.push({[daily]: 1})
                            }
                        })
                    }
                    dailyData.sort((a, b) => {
                        if(moment(Object.keys(a)[0]).isAfter(moment(Object.keys(b)[0]))) return 1
                        if(moment(Object.keys(a)[0]).isBefore(moment(Object.keys(b)[0]))) return -1
                        return 0
                    })
                    this.setState({ isLoading: false, heatmap, dailyData })
                })
                .catch(err => {
                    console.log(err)
                    if (err.response && err.response.status && err.response.status === 403) {
                        this.handleNavigate('main')
                    } else setTimeout(() => this.handleNavigate(`my/venues`), 150)
                })
        }
    }

    getSplash() {
        return <div className='My-Splash'>
            <img src={Logo} className='Node-Logo' alt="GigLoca" />
        </div>
    }

    getBounce() {
        return <div className='Pref-Bounce'>
            <img src={Logo} className='Node-Logo' alt="GigLoca" />
            <div className='Node-Content'>Become part of the fun by Logging In or Joining GigLoca.</div>
        </div>
    }

    getMessage() {
        return <div className='Node-Confirm'>
            <div className='Node-Row Confirm-Text'>{this.state.msg}</div>
            <div className="Node-Row Node-Flex-Wrap">
                <div className='Pref-Button Pref-Button-Save' onClick={() => this.handleMsgOK()}>OK</div>
            </div>
        </div>
    }

    getByDay() {   
        return <div className='Node-Row'><Bar data={{
            labels: this.state.dailyData.map(dd => Object.keys(dd)[0]),
            datasets: [
                {
                    label: "Searches",
                    strokeColor: "#fff",
                    fillColor: "#fff",
                    HighlightFill: "#fff",
                    HighlightStroke: "#fff",
                    backgroundColor: "#fff",
                    data: this.state.dailyData.map(dd => Object.values(dd)[0])
                }
            ]
        }} width={250} height={250} options={{ datasetFill: true, scaleGridLineColor: '#fff', scales: { yAxes: [{ ticks: { suggestedMin: 50 } }] }, legend: {display: false} }}
        /></div>
    }

    render() {
        //console.log(this.state, this.props)
        return <div className={`My-Container Node-${this.props.mode}`}>
            <TopMenu
                mode={this.props.mode}
                onMode={this.handleModeChange}
                onPref={this.handleOnPrefSelect}
                notifications={this.props.user ? (this.props.user.notifications && this.props.user.notifications.length > 0 ? this.props.user.notifications.length : true) : null}
                onNotifications={this.handleOnNotificationsSelect}
                user={this.props.user ? { firstName: this.props.user.firstName, image: this.props.user.image } : null}
                onSettings={this.handleDisplaySettings}
                displaySettings={this.state.displaySettings}
                pref={null} />

            {
                this.state.splash ? this.getSplash() : (this.state.bounce ? this.getBounce() : null)
            }
            {
                this.state.displayMsg && this.getMessage()
            }
            {
                this.state.heatmap && this.state.lat && this.state.lng && <HeatMap data={this.state.heatmap} lat={this.state.lat} lng={this.state.lng} />
            }
            {
                this.state.dailyData && this.getByDay()
            }
            <BottomMenu
                menu={this.state.menu}
                onLeft={this.handleLeftMenu}
                onGiglit={this.handleGiglit}
                isLoading={this.state.isLoading}
                 />
        </div>
    }
}

export default withRouter(Analytics)